const runtimeConfig = window.__RUNTIME_CONFIG__;
const clientConfigured = (runtimeConfig?.REACT_APP_CLIENT_URL ?? process.env.REACT_APP_CLIENT_URL) ?? '';
const clientWithoutBackslash = clientConfigured.replace(/\/$/, "");
const clientWithBackslash = clientWithoutBackslash + '/';
// STS URL's need to be exactly the same, so the backslash needs to match this.
export default {
    appTitle: runtimeConfig?.REACT_APP_TITLE ?? process.env.REACT_APP_TITLE ?? '',
    version: runtimeConfig?.REACT_APP_VERSION ?? process.env.REACT_APP_VERSION ?? '',
    env: runtimeConfig?.REACT_APP_ENV ?? process.env.REACT_APP_ENV,
    apiUrl: runtimeConfig?.REACT_APP_API_URL ?? process.env.REACT_APP_API_URL ?? '',
    mediaUrl: runtimeConfig?.REACT_APP_MEDIA_URL ?? process.env.REACT_APP_MEDIA_URL ?? '',
    mediaSuffix: runtimeConfig?.REACT_APP_MEDIA_SUFFIX ?? process.env.REACT_APP_MEDIA_SUFFIX ?? '',
    infoUrl: runtimeConfig?.REACT_APP_INFO_URL ?? process.env.REACT_APP_INFO_URL ?? 'https://www.vcsobservation.com/zorg/babywatch',
    authentication: {
        authority: runtimeConfig?.REACT_APP_STS_URL ?? process.env.REACT_APP_STS_URL ?? '',
        clientId: "community",
        clientRoot: clientWithoutBackslash,
        scope: "openid profile email community_api",
        redirectUri: clientWithBackslash + "callback",
        automaticSilentRenew: true,
        silentRedirectUri: clientWithBackslash + "silent-renew.html",
        responseType: "code",
        postLogoutRedirectUri: clientWithoutBackslash,
        endSessionEndpoint: clientWithoutBackslash
    }
};
